import { lib } from 'src/Utils'

function canManageProject(currentUser) {
  const user = currentUser || lib.ls.getCurrentUser()

  return user.is_owner || user.is_admin
}

export default canManageProject